// extracted by mini-css-extract-plugin
export default {"container":"ThankYou_container__-Biet","dancing":"ThankYou_dancing__WIxmG"};